/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedinfolink2Inputs */

const en__field_inheritedinfolink2 = /** @type {(inputs: _Field_Inheritedinfolink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`info link (derived)`)
};

const de__field_inheritedinfolink2 = /** @type {(inputs: _Field_Inheritedinfolink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info Link (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "info link (derived)" |
*
* @param {_Field_Inheritedinfolink2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedinfolink2 = /** @type {((inputs?: _Field_Inheritedinfolink2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedinfolink2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedinfolink2(inputs)
	return de__field_inheritedinfolink2(inputs)
});
export { _field_inheritedinfolink2 as "_field_inheritedInfoLink" }